import Blockquote from './Blockquote'
import StatsNumber from './Statsnumber'

export * from './Headings'
export * from './Paragraph'
export { Blockquote, StatsNumber }
